export default __webpack_public_path__ + "static/media/create-team.828f73c7.svg";